import {
  FormField,
  FormSubmitButton,
  FormWrapper,
} from "@/components/form/common";
import { Checkbox, SingleSelect } from "@/components/form/fields";
import { Input } from "@rumble-it/common-components/components";
import { createAction } from "@/pages/admin/rules/actions/lib/actions";
import { useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";

export const CreateActionForm = ({ rules, actiontypes }) => {
  const {
    control,
    handleSubmit,
    setError,
    register,
    setValue,
    formState: { errors, isSubmitting },
  } = useForm();
  const navigate = useNavigate();

  const onSubmit = async (data) => {
    try {
      const response = await createAction(data, navigate);

      if (response.errors) {
        Object.keys(response.errors).forEach((field) =>
          setError(field, { type: "manual", message: response.errors[field] }),
        );
      }
    } catch {
      setError("root", { type: "manual", message: "An error occurred" });
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <FormWrapper>
        <FormField name="rule" label="Rule" formState={{ errors }}>
          <SingleSelect
            placeholder="Selecteer rule"
            options={rules}
            {...register("rule", { required: "Rule is required" })}
            onChange={(value) => setValue("rule", value)}
          />
        </FormField>
        <FormField
          name="ruleActionType"
          label="Actie type"
          formState={{ errors }}
        >
          <SingleSelect
            placeholder="Selecteer actie type"
            options={actiontypes}
            {...register("ruleActionType", {
              required: "Actie type is required",
            })}
            onChange={(value) => setValue("ruleActionType", value)}
          />
        </FormField>
        <FormField name="name" label="Naam" formState={{ errors }}>
          <Controller
            name="name"
            control={control}
            rules={{ required: "Naam is required" }}
            render={({ field }) => <Input {...field} className="w-full" />}
          />
        </FormField>
        <FormField
          name="description"
          label="Omschrijving"
          formState={{ errors }}
        >
          <Controller
            name="description"
            control={control}
            render={({ field }) => <Input {...field} className="w-full" />}
          />
        </FormField>
        <FormField name="data" label="Data" formState={{ errors }}>
          <Controller
            name="data"
            control={control}
            rules={{ required: "Data is required" }}
            render={({ field }) => <Input {...field} className="w-full" />}
          />
        </FormField>
        <FormField name="priority" label="Prioriteit" formState={{ errors }}>
          <Controller
            name="priority"
            control={control}
            rules={{ required: "Prioriteit is required" }}
            render={({ field }) => (
              <Input {...field} className="w-full" type="number" />
            )}
          />
        </FormField>
        <FormField name="active" label="Actief" formState={{ errors }}>
          <Controller
            name="active"
            control={control}
            render={({ field }) => <Checkbox {...field} />}
          />
        </FormField>
        <FormField
          name="delayInSeconds"
          label="Vertraging (sec)"
          formState={{ errors }}
        >
          <Controller
            name="delayInSeconds"
            control={control}
            rules={{ required: "Vertraging (sec) is required" }}
            render={({ field }) => (
              <Input {...field} className="w-full" type="number" />
            )}
          />
        </FormField>
        <FormField name="synchronous" label="Synchroon" formState={{ errors }}>
          <Controller
            name="synchronous"
            control={control}
            render={({ field }) => <Checkbox {...field} />}
          />
        </FormField>
        <FormSubmitButton disabled={isSubmitting} isSubmitting={isSubmitting}>
          {isSubmitting ? "Submitting..." : "Aanmaken"}
        </FormSubmitButton>
      </FormWrapper>
    </form>
  );
};
